import type { Meta, StoryFn } from '@storybook/react';

import { Image } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Image',
  component: Image
} as Meta;

export const ImageDemo: StoryFn = () => {
  return (
    <Image src='https://www.pega.com/themes/custom/pegawww_theme/images/pega-logo.svg' alt='Pega' />
  );
};
